import * as React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link'
import { useNavigate } from 'react-router-dom'

export default function StaticFooter() {
  const navigate = useNavigate()

  const handleNavClick = (e) => {
    let path = e.currentTarget.href.replace(/https?\:\/\//, '')
      .replace(e.currentTarget.host, '')
    navigate(path)
    e.preventDefault()
    e.stopPropagation()
  }

  return (
    <React.Fragment>
      <Box sx={{ bgcolor: 'background.paper', p: 6 }} component="footer">
          <Typography variant="body2" align="center" gutterBottom>
            <Link
              onClick={handleNavClick}
              href='/news'>
                News
              </Link>
            &nbsp;|&nbsp;
            <Link 
              onClick={handleNavClick}
              href='/app/policy'>
                Privacy Policy
              </Link>
            &nbsp;|&nbsp;
            <Link href="mailto:contact@stikis.com">Contact us</Link>
            &nbsp;| Created by&nbsp;
            <Link href="https://jareddonovan.com">
              Jared Donovan
            </Link>
          </Typography>
      </Box>
    </React.Fragment>
  )
}